<div class="validation-container">
    <rask-virkeskop-validation-message
        entityType="skogsvardsatgardovrigt"
        [entityGuid]="skogsvardsAtgard.guid">
    </rask-virkeskop-validation-message>
</div>

@if (isSkogsvardSiktrojningOnRundvirke()) {
<div>
    <rask-radiobutton-group
        class="vertical"
        label="Ska siktröjningen ingå i avverkningkostnaden?"
        [buttons]="[{key:true, value:'Ja'}, {key:false, value:'Nej'}]"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        [(ngModel)]="skogsvardsAtgard.indirektKostnad"
        (change)="onIndirektKostnadChange()">
    </rask-radiobutton-group>
</div>
}
<rask-label class="col-lg-12 mb-0 pt-3 ovrigtRaskLabel">Välj önskat sätt för kontaktpersonen att få information om
    slutförd åtgärd</rask-label>
<div>
    <rask-checkbox #slutrapporteradEpost
        class="low"
        text="Skicka information via E-post"
        aid="slutrapporteradEpost"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        (change)="onSlutrapporteradChange()">
    </rask-checkbox>
    <rask-checkbox #slutrapporteradSms
        class="low"
        text="Skicka information via SMS"
        aid="slutrapporteradSms"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        (change)="onSlutrapporteradChange()">
    </rask-checkbox>
    <rask-checkbox #slutrapporteradSkickaInte
        class="low"
        text="Skicka inte information"
        aid="slutrapporteradSkickaInte"
        [disabled]="kontraktReadonly || skogsvardsAtgard.isReadonly"
        (change)="onSlutrapporteradChange()">
    </rask-checkbox>

</div>
<div class="row">
    <div class="col-12">
        <rask-textarea
            class="w-100 mt-4 mb-4"
            label="Upphandlarkommentar"
            placeholder="Här kan du skriva en anteckning som endast är till planeraren och som inte når arbetsordern eller markägare."
            [rows]="4"
            [maxlength]="2000"
            [(ngModel)]="skogsvardsAtgard.upphandlarkommentar"
            [disabled]="skogsvardsAtgard.isReadonly"
            (change)="onOvrigtChange()"
            aid="upphandlarkommentar">
        </rask-textarea>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <rask-kontrakt-dokument
            [placeholderText]="'VIRKESKOP_ANBUD_KONTRAKT_TILLAGDA_FILER_LAGG_TILL_BILAGA_SVP' | translate"
            [dokumenttyp]="blobStorageDokumentTypSkogsvardBilaga"
            [atgardId]="skogsvardsAtgard.id"
            [isForKontrakt]="false"
            [multiple]="true"
            [readonly]="kontraktReadonly"></rask-kontrakt-dokument>
    </div>
</div>